<com-snackbar></com-snackbar>
<com-toast></com-toast>
<com-navbar-routes #navbarRoutesRef></com-navbar-routes>

<div class="container-fluid">
  <div class="row h-100">
    <!-- <com-inner-sidebar (siblingRoutesPresentCheck)="isSiblingRoutePresent($event)"></com-inner-sidebar> -->
    <div class="col h-100">
      <div class="row" [ngClass]="{'ms-md-5': siblingRoutesPresent, 'ms-5': proSidebarPresent}">
        <div class="col-12 align-items-center shadow-sm bg-white content-heading-container"
          [ngClass]="!configService?.pageTitle ? 'd-none': 'd-flex'">
          <com-page-header class="w-100">
            <ng-container [ngTemplateOutlet]="configService?.pageHeaderExtraTemplateRef"></ng-container>
          </com-page-header>
        </div>
      </div>
      <div class="row overflow-auto" id="content-overflow-container" [ngStyle]="{'--extra-height' : configService?.pageTitle ? '6.25rem' : '0rem'}" [ngClass]="{'ms-md-5': siblingRoutesPresent, 'ms-5': proSidebarPresent}">
        <div class="col-12" [ngClass]="{'my-3 px-md-4': configService?.pageTitle, 'px-0 overflow-hidden': !configService?.pageTitle}">
          <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate()"></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>